import { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from 'contexts/AuthContext'

type GuestGuardProps = {
  children: ReactElement
}

function GuestGuard({ children }: GuestGuardProps) {
  const { isLoggedIn } = useAuth()

  if (isLoggedIn) {
    return <Navigate to="/" replace />
  }

  return children
}

export default GuestGuard
